module.exports = __webpack_public_path__ + "static/media/view.5426cae2.svg";